import { StyleSheet } from 'react-native';
import { useIsFocused, useNavigation } from '@react-navigation/native';
import ListItem from 'components/atoms/ListItem';
import HStack from 'components/atoms/stack/HStack';
import VStack from 'components/atoms/stack/VStack';
import ThemedBlock from 'components/atoms/ThemedBlock';
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList';
import ManagementHeader from 'components/management/molecules/ManagementHeader';
import { configClient } from 'components/provider/ConfigProvider';
import _ from 'lodash';
import { AppRoutes } from 'navigations/app-routes';
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { dataConstants } from 'services/redux/data/constants';
import { listArrow } from 'styles/list';
import Button from 'theme/Button';
import Text from 'theme/Text';
import { managementRightsConstants } from 'utils/constants/management-right-constants';
import FetchCreditBundles from "utils/fetch/FetchCreditBundles";
import FetchCreditQrCodes from 'utils/fetch/FetchCreditQrCodes';
import { useShowHamburger } from "utils/helper-device";
import HelperManagementRights from 'utils/helper-management-rights';
import { openUrl } from 'utils/helper-url';
import HelperPrice from 'utils/helper/HelperPrice';
import useFetch from "utils/hooks/useFetch";
import i18n from "utils/i18n";
import Translate from 'utils/translate';

const ManagementCreditBundlesQr = () => {

    const showHamburger = useShowHamburger();
	const navigation = useNavigation();
	const isFocused = useIsFocused();

	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
    
	const [ search, setSearch ] = useState('')

    const { data: creditQrCodes, loading, refetch } = useFetch( FetchCreditQrCodes.fetchAll, {
		variables: {
			status: [ 'active', 'inactive' ],
		}
	} );
	
	useEffect( () => {
		if( isFocused ) {
			refetch();
		}
	}, [ isFocused ] );

	const openCreditQrCode =  ( creditQrCode ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_CREDIT_BUNDLES_QR_EDIT, {
			guid: creditQrCode.guid
		} );
	}

	const createCreditQrCode = () => {
		openCreditQrCode( {} );
	}

	const onPressDownloadPDF = ( item ) => {
		const type = 'a4';
		const url = configClient.url() + `/connection/rest/pdf/generate/type/${type}/guid/creditqr:${ item.guid }`;

		openUrl( url, '_blank' );
	}
	
	const renderItem = ( { item, index } ) => {
		const timeslotKind = _.find( _timeslotKinds, { guid: item?.timeslot_kind?.guid } )
		const timeslotKindTitle = Translate.field( timeslotKind, 'title' )

		const itemTitle = Translate.field( item, 'title' );
		item.title = timeslotKindTitle + ' - ' + itemTitle;

		return (
			<ListItem
				title={ item.title }
				subtitle={ HelperPrice.format( item?.credit_bundle?.price ) +' - '+ item?.credit_bundle?.credits_amount  }
                accessoryRight={(
					<HStack>

						<Button
							style={staticStyles.buttonWidth170}
							onPress={ onPressDownloadPDF.bind( this, item ) }>

							{ i18n.t(`management:pages.credits.generate_file`) }
						</Button>
					</HStack>
				)}
				onPress={ openCreditQrCode.bind( this, item ) }>

				<VStack>
					<Text appearance={'hint'}>{ i18n.t('management:generic.active.' + ( item.status === 'active' ? 'yes' : 'no' )) }</Text>
				</VStack>
			</ListItem>
		)
	}
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:form.search.title'),
					onChangeText: _.debounce( setSearch, 400 )
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) ? { onPress: createCreditQrCode } : null }
		/>
	);
	
	const filters = _.size( search ) > 2 ? [ {field: 'name', kind: 'contains', value: search } ] : null;

	if( loading ) {
		return (
			<ThemedLoader
				text={ i18n.t( 'loading.timeslot_groups' ) }
			/>
		)
	}
	
	return (
		<VStack>
			<ManagementGroupedThemeList
				header={ header }
				items={ creditQrCodes }
				renderItem={ renderItem.bind( this ) }
				filters={ filters }
				groupByKey={ 'status' }
				groupByValues={ [
					'active',
					'inactive'
				] }
			/>

			<ThemedBlock
				mediumPadding>

				<Text textAlign='center'>{ i18n.t(`management:pages.credits.generate_text`) }</Text>
			</ThemedBlock>
		</VStack>
    )
}

const staticStyles = StyleSheet.create({
	buttonWidth170: {
		width: 170,
	},
});

export default ManagementCreditBundlesQr;
